import { render, staticRenderFns } from "./VehicleDispatch.vue?vue&type=template&id=5bd659b2&scoped=true&"
import script from "./VehicleDispatch.vue?vue&type=script&lang=js&"
export * from "./VehicleDispatch.vue?vue&type=script&lang=js&"
import style0 from "./VehicleDispatch.vue?vue&type=style&index=0&id=5bd659b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd659b2",
  null
  
)

export default component.exports